import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * ProtectedRoute Component
 * Protects routes that require authentication
 * Redirects to sign in page if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="auth-container">
        <div style={{ textAlign: "center" }}>
          <div className="loading-spinner">Loading...</div>
        </div>
      </div>
    );
  }

  // Redirect to sign in if not authenticated
  if (!currentUser) {
    return <Navigate to="/signin" replace />;
  }

  // Render protected content if authenticated
  return children;
};

export default ProtectedRoute;